// ------------------------------------------------------------------------------
// name: index
// author: mudas
// created: 2025/9/30
// ------------------------------------------------------------------------------

// 提现状态类型
export enum WithdrawStatus {
  Pending = 10,
  Processing = 25,
  Failed = 20,
  Success = 30,
}

export const WithdrawStatusName = {
  [WithdrawStatus.Pending]: '提现中',
  [WithdrawStatus.Processing]: '提现处理中',
  [WithdrawStatus.Failed]: '提现失败',
  [WithdrawStatus.Success]: '提现成功',
} as const;

export enum WithdrawConfirmType {
  Paid = 'paid',
  PayFailed = 'payFail',
}

// 提现方式
export enum WithdrawChannel {
  Alipay = 0,
  BankCard = 1,
  Offline = 2,
}

// 提现方式名称
export const WithdrawChannelName = {
  [WithdrawChannel.Alipay]: '支付宝',
  [WithdrawChannel.BankCard]: '银行卡',
  [WithdrawChannel.Offline]: '线下',
} as const;